import { render, staticRenderFns } from "./formtable.vue?vue&type=template&id=757d40e5&scoped=true"
import script from "./formtable.vue?vue&type=script&lang=js"
export * from "./formtable.vue?vue&type=script&lang=js"
import style0 from "./formtable.vue?vue&type=style&index=0&id=757d40e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757d40e5",
  null
  
)

export default component.exports